import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const AppContext = createContext(null);

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [state, setState] = useState({
    loading: false,
    departments: [],
    department: null,
    showDepartments: false,
  });

  const setDepartment = useCallback((department) => {
    setState((prev) => ({
      ...prev,
      department,
      showDepartments: false,
    }));
  }, []);

  const setDepartments = useCallback((departments) => {
    setState((prev) => ({
      ...prev,
      departments,
    }));
  }, []);

  const setShowDepartments = useCallback((showDepartments) => {
    setState((prev) => ({
      ...prev,
      showDepartments,
    }));
  }, []);

  const setLoading = useCallback((loading) => {
    setState((prev) => ({
      ...prev,
      loading,
    }));
  }, []);

  const value = {
    ...state,
    setDepartment,
    setDepartments,
    setShowDepartments,
    setLoading,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
